import { FilterOutlined } from '@ant-design/icons';
// eslint-disable-next-line no-use-before-define
import * as React from 'react';

import {
  AssigneesFilter,
  ProjectSearchAssigneesFilterProps,
  ProjectSearchTag
} from '../../../../clients/shared/ProjectSearch';
import styles from '../../../../clients/shared/ProjectSearch/filters.module.css';
import MoreFilters, { PROJECT_SEARCH_SEVERITIES } from './MoreFilters';
import PageFilter from './PageFilter';
import SortBy from './SortBy';

export {
  assigneeListHeight,
  availableAssigneeDropdownHeight,
  filterAssigneeUsers,
  selectedAssigneeFilters
} from '../../../../clients/shared/ProjectSearch/AssigneesFilter';

export const FilterBar: React.FC<Omit<
  ProjectSearchAssigneesFilterProps,
  'onOpenChange' | 'open'
> & {
  createdByUsers: ProjectSearchAssigneesFilterProps['users'];
  showPublicFeedback: boolean;
  tags: ProjectSearchTag[];
}> = ({ createdByUsers, showPublicFeedback, tags, ...props }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <div className={styles.filterBar}>
      <FilterOutlined className={styles.filterIcon} />
      <PageFilter filters={props.filters} onChange={props.onChange} />
      <AssigneesFilter {...props} onOpenChange={setOpen} open={open} />
      <MoreFilters
        currentUser={props.currentUser}
        filters={props.filters}
        onChange={props.onChange}
        severities={PROJECT_SEARCH_SEVERITIES}
        showCommentsFilter
        showPublicFeedback={showPublicFeedback}
        tags={tags}
        users={createdByUsers}
      />
      <SortBy />
    </div>
  );
};

export default AssigneesFilter;
